import { vnTemplate } from "./vnTemplate";
import { infoButton_template } from "./infoButton_template";
export class multipleSelector_template extends vnTemplate {
    constructor() {
        super(...arguments);
        this.tagContainerId = 'filters-selected';
        this.tagContainerCaption = 'Selected Filters:';
    }
    getTemplateHtml() {
        return /* html */ `
            <div class="dropdown" data-bind="attr: { id: 'multipleSelector_' + elementIdentifier()}, css: { 'is-no-header' : !selectAllEnabled() && !searchEnabled }">
                <button type="button" class="dropdown-toggle icon" data-bind="text: label"></button>
                <!-- ko if: !isDisabled() -->
                <div data-bind="class: 'dropdown-list '">
                    <div class="w-multi-dropdown">
                        <div class="w-multi-dropdown-header">

                             <!-- ko if: selectAllEnabled() -->
                             <div class="multi-dropdown-header">
                                <button class="btn" type="button" id="select_all" data-bind="disable: isDisabled(), event: { click: onSelectAllAction}">Select All</button>
                                <button class="btn" type="button" id="deselect_all" data-bind="disable: isDisabled(), event: { click: onDeselectAllAction}">Deselect All</button>
                             </div>
                             <!-- /ko -->

                            <!-- ko if: searchEnabled() && (isMutliLevel() || !selectAllEnabled()) -->
                            <div class="multi-dropdown-header">
                                <div class="w-search icon i-search2">
                                    <input class="multi-dropdown-search" type="text" data-bind="textInput: searchValue, event: { keyup: onSearchAction}">
                                </div>
                            </div>
                            <!-- /ko -->
                        </div>


                        <div class="multi-dropdown-body" data-bind="class: isMutliLevel() ? 'is-multi' : ''">


                            <ul class="multi-dropdown-list" data-bind="attr: { id: 'multipleSelector_content_' + elementIdentifier()}">
                                <!-- ko if: isMutliLevel() -->
                                <!-- ko foreach: groups -->
                                <li data-bind="class: ($parent.openedGroupsDrawers.indexOf(name) != -1 || ($parent.searchValue != '' && $parent.searchMatches.indexOf(name) != -1)) ? 'multi-dropdown-item is-open' : 'multi-dropdown-item', style: { display: ($parent.searchValue() != '' && $parent.searchMatches.indexOf(name) == -1) ? 'none' : 'block' }">
                                    <div class="w-input">
                                        <button class="btn-collapse icon i-dropdown-simple-b" type="button" data-bind="event: { click: $parent.onClickGroupDrawerAction.bind($parent)}"></button>
                                        <input class="icon" data-bind="disable: $parent.isDisabled(), value: name, checked: $parent.selectedGroups, attr:{id: 'group_' + $parent.elementIdentifier() + '_' + name}, event: { click: $parent.onClickGroupFilterAction.bind($parent)}" type="checkbox">
                                        <label class="icon i-check" data-bind="text: name, attr:{for: 'group_' + $parent.elementIdentifier() + '_' + name}"></label>
                                    </div>

                                    <div class="multi-dropdown-collapse">
                                        <ul class="multi-dropdown-list">
                                            <!-- ko foreach: items -->
                                            <li class="multi-dropdown-item" data-bind="style: { display: ($parents[1].searchValue() != '' && $parents[1].searchMatches.indexOf(name) == -1) ? 'none' : 'block' }">
                                                <div class="w-input">
                                                    <input class="icon" data-bind="disable: $parents[1].isDisabled(), value: id, checked: $parents[1].selectedItems, attr:{id: 'item_' + $parents[1].elementIdentifier() + '_' + id}, event: { click: $parents[1].onClickItemFilterAction.bind($parents[1])}" type="checkbox">
                                                    <label class="icon i-check" data-bind="text: name, attr:{for: 'item_' + $parents[1].elementIdentifier() + '_' + id}"></label>
                                                    <!-- ko if: $data.tooltip -->
                                                    <div class="w-tooltips-adv pos-right short" data-bind="template: { name: 'infoButton-template', data: $data.tooltip.getTemplateViewModel() }"></div>
                                                    <!-- /ko -->
                                                    <!-- ko if: $parents[1].displaySelectionOrder() -->
                                                        <!-- ko if: $parents[1].selectedItemsOrderBySelection.indexOf(id) != -1 -->
                                                            <span class="note" data-bind="text: $parents[1].selectedItemsOrderBySelection.indexOf(id) + 1"></span>
                                                        <!-- /ko -->
                                                    <!-- /ko -->
                                                </div>
                                            </li>
                                            <!-- /ko -->
                                        </ul>
                                    </div>
                                </li>
                                <!-- /ko -->
                                <!-- /ko -->

                                <!-- ko ifnot: isMutliLevel() -->
                                <!-- ko foreach: items -->
                                <li class="multi-dropdown-item" data-bind="style: { display: ($parent.searchValue() != '' && $parent.searchMatches.indexOf(name) == -1) ? 'none' : 'block' }">
                                    <div class="w-input">
                                        <input class="icon" data-bind="disable: $parent.isDisabled(), value: id, checked: $parent.selectedItems, enable: $parent.selectedItems().indexOf($data.id) !== -1 || !$parent.selectionLimitHit(), attr:{id: 'item_' + $parent.elementIdentifier() + '_' + id}, event: { click: $parent.onClickItemFilterAction.bind($parent)}" type="checkbox">
                                        <!-- ko if: (typeof itemIcon === 'undefined') || !itemIcon -->
                                            <label class="icon i-check" data-bind="text: name, attr:{for: 'item_' + $parent.elementIdentifier() + '_' + id}, class: (typeof itemClass !== 'undefined') && itemClass ? itemClass : ''"></label>
                                        <!-- /ko -->
                                        <!-- ko if: (typeof itemIcon !== 'undefined') && itemIcon -->
                                            <label class="icon i-check" data-bind="html: name + itemIcon, attr:{for: 'item_' + $parent.elementIdentifier() + '_' + id}, class: (typeof itemClass !== 'undefined') && itemClass ? itemClass : ''"></label>
                                        <!-- /ko -->
                                        <!-- ko if: $data.tooltip -->
                                        <div class="w-tooltips-adv pos-right short" data-bind="template: { name: 'infoButton-template', data: $data.tooltip.getTemplateViewModel() }"></div>
                                        <!-- /ko -->
                                        <!-- ko if: $parent.displaySelectionOrder() -->
                                            <!-- ko if: $parent.selectedItemsOrderBySelection.indexOf(id) != -1 -->
                                                <span class="note" data-bind="text: $parent.selectedItemsOrderBySelection.indexOf(id) + 1"></span>
                                            <!-- /ko -->
                                        <!-- /ko -->
                                    </div>
                                </li>
                                <!-- /ko -->
                                <!-- /ko -->
                            </ul>
                        </div>
                    </div>
                </div>
                <!-- /ko -->
            </div>
            `;
    }
    getTemplateName() {
        return "multiSelector-template";
    }
    getMainElementClasses() {
        return [this.filterContainerClass];
    }
    buildViewModel() {
        // define the viewmodel data/ functions
        let huit_neuf_this = this;
        return {
            groups: ko.observableArray([]),
            items: ko.observableArray([]),
            label: ko.observableArray([]),
            selectedItems: ko.observableArray([]),
            selectedGroups: ko.observableArray([]),
            searchMatches: ko.observableArray([]),
            openedGroupsDrawers: ko.observableArray([]),
            selectedItemsOrderBySelection: ko.observableArray([]),
            separateFilter: ko.observable(false),
            elementIdentifier: ko.observable(this.idElement),
            selectAllEnabled: ko.observable(true),
            searchEnabled: ko.observable(true),
            selectionLimit: ko.observable(0) // zero for disabled
            ,
            selectionLimitHit: ko.observable(false),
            displaySelectionOrder: ko.observable(false),
            isMutliLevel: ko.observable(false),
            searchValue: ko.observable(""),
            isDisabled: ko.observable(false),
            onClickFilterList: function (data) { huit_neuf_this.onClickFilterList(data); },
            onSearchAction: function () { huit_neuf_this.onSearchAction(); },
            onClickItemFilterAction: function (data) { huit_neuf_this.onClickFilterList(data); return true; },
            onClickGroupFilterAction: function (data) { huit_neuf_this.onClickGroupFilterList(data); return true; },
            onClickGroupDrawerAction: function (data) { huit_neuf_this.onClickGroupDrawerAction(data); return true; },
            onSelectAllAction: function () { huit_neuf_this.onSelectAllAction(); },
            onDeselectAllAction: function () { huit_neuf_this.onDeselectAllAction(); },
            setTags: function (selectedItems, allItems) { huit_neuf_this.setTags(selectedItems, allItems); }
        };
    }
    onDeselectAllAction() {
        this.viewModel[this.idElement].selectedItems([]);
        this.viewModel[this.idElement].selectedGroups([]);
        this.viewModel[this.idElement].openedGroupsDrawers([]);
        this.viewModel[this.idElement].selectedItemsOrderBySelection([]);
        this.removeTagContainer();
        this.applyFilter();
    }
    onSearchAction() {
        let searchValue = this.getSearchValue();
        if (searchValue == '') {
            this.getTemplateViewModel().searchMatches([]);
            return;
        }
        let matches = [];
        if (this.getTemplateViewModel().isMutliLevel()) {
            for (let group of this.getTemplateViewModel().groups()) {
                if (group.name.search(new RegExp(searchValue, "i")) != -1 && matches.indexOf(group.name) == -1) {
                    matches.push(group.name);
                }
                for (let item of group.items) {
                    if (item.name.search(new RegExp(searchValue, "i")) != -1 && matches.indexOf(item.name) == -1) {
                        matches.push(item.name);
                        if (matches.indexOf(group.name) == -1) {
                            matches.push(group.name);
                        }
                    }
                }
            }
        }
        else {
            for (let item of this.getTemplateViewModel().items()) {
                if (item.name.search(new RegExp(searchValue, "i")) != -1 && matches.indexOf(item.name) == -1) {
                    matches.push(item.name);
                }
            }
        }
        this.getTemplateViewModel().searchMatches(matches);
    }
    onClickFilterList(item) {
        this.checkLimit();
        this.showItemFilters(item, this.getSelectedItems(), this.getItems());
        this.applyFilter();
    }
    checkLimit() {
        let selectionLimit = this.viewModel[this.idElement].selectionLimit();
        let selectedItems = this.getSelectedItems();
        if (selectionLimit > 0) {
            if (selectedItems.length == selectionLimit) {
                this.viewModel[this.idElement].selectionLimitHit(true);
            }
            else {
                this.viewModel[this.idElement].selectionLimitHit(false);
            }
        }
        else {
            this.viewModel[this.idElement].selectionLimitHit(false);
        }
    }
    onClickGroupFilterList(group) {
        let selectedGroups = this.getSelectedGroups();
        let selectedItems = this.getSelectedItems();
        if (selectedGroups.indexOf(group.name) != -1) {
            for (let item of group.items) {
                if (selectedItems.indexOf(item.id) == -1) {
                    this.getTemplateViewModel().selectedItems.push(item.id);
                    this.showItemFilters(item, this.getSelectedItems(), this.getItems());
                }
            }
            let openedGroupsDrawers = this.getOpenedGroupsDrawers();
            if (openedGroupsDrawers.indexOf(group.name) == -1) {
                openedGroupsDrawers.push(group.name);
            }
            this.getTemplateViewModel().openedGroupsDrawers(openedGroupsDrawers);
        }
        else {
            for (let item of group.items) {
                if (selectedItems.indexOf(item.id) != -1) {
                    this.getTemplateViewModel().selectedItems.remove(item.id);
                    this.showItemFilters(item, this.getSelectedItems(), this.getItems());
                }
            }
        }
        this.applyFilter();
    }
    onClickGroupDrawerAction(group) {
        let openedGroupsDrawers = this.getOpenedGroupsDrawers();
        let index = openedGroupsDrawers.indexOf(group.name);
        if (index != -1) {
            openedGroupsDrawers.splice(index, 1);
        }
        else {
            openedGroupsDrawers.push(group.name);
        }
        this.getTemplateViewModel().openedGroupsDrawers(openedGroupsDrawers);
    }
    showItemFilters(lastSelectedItem, selectedItems, allItems) {
        let huit_neuf_this = this;
        this.removeTagContainer();
        let isCaptionAppended = false;
        for (let item of allItems) {
            if (selectedItems.indexOf(item.id) != -1) {
                if (!isCaptionAppended) {
                    this.addCaption();
                    isCaptionAppended = true;
                }
                this.addTag(item);
            }
        }
        this.updateSelectedItemsOrderBySelection(lastSelectedItem);
    }
    setTags(selectedItems, allItems) {
        this.removeTagContainer();
        let isCaptionAppended = false;
        for (let item of allItems) {
            if (selectedItems.indexOf(item.id) != -1) {
                if (!isCaptionAppended) {
                    this.addCaption();
                    isCaptionAppended = true;
                }
                this.addTag(item);
            }
        }
    }
    onSelectAllAction() {
        let huit_neuf_this = this;
        let allItems = this.viewModel[this.idElement].items();
        if (this.getTemplateViewModel().isMutliLevel()) {
            let allGroups = this.viewModel[this.idElement].groups();
            this.setSelectedGroups(allGroups);
        }
        else {
            this.setSelectedItems(allItems);
        }
        this.removeTagContainer();
        let isCaptionAppended = false;
        for (let item of allItems) {
            if (!isCaptionAppended) {
                this.addCaption();
                isCaptionAppended = true;
            }
            this.addTag(item);
        }
        this.applyFilter();
    }
    setSelectedItems(selectedItems, showTags = false) {
        let items = [];
        for (let c of selectedItems) {
            items.push(c.id);
        }
        this.setSeletedItemIds(items, showTags);
    }
    setSeletedItemIds(items, showTags = false) {
        this.viewModel[this.idElement].selectedItems(items);
        this.checkLimit();
        if (showTags) {
            this.addCaptionAndSelectedTags();
        }
    }
    setSelectedGroups(selectedGroups) {
        let items = [];
        let groups = [];
        let allGroups = this.getGroups();
        console.log(allGroups);
        for (let selectedGroup of selectedGroups) {
            let selectedGroupName = selectedGroup.name;
            let selectedGroupData = allGroups.find(i => i.name === selectedGroupName);
            for (let item of selectedGroupData.items) {
                items.push(item.id);
            }
            groups.push(selectedGroupName);
        }
        this.viewModel[this.idElement].selectedGroups(groups);
        this.viewModel[this.idElement].selectedItems(items);
    }
    setSelectedItemsOrderBySelection(selectedItemsOrderBySelection) {
        let items = [];
        for (let c of selectedItemsOrderBySelection) {
            items.push(c.id);
        }
        this.viewModel[this.idElement].selectedItemsOrderBySelection(items);
    }
    setSeparateFilter(separateFilter) {
        this.getTemplateViewModel().separateFilter(separateFilter);
    }
    setItems(items) {
        let i = 0;
        for (let item of items) {
            item = this.addTooltipData(item, i++);
        }
        this.getTemplateViewModel().items(items);
        this.getTemplateViewModel().groups(items);
    }
    setMultiSectionItems(groups) {
        let items = [];
        let i = 0;
        for (let group of groups) {
            group = this.addTooltipData(group, i++);
            for (let item of group.items) {
                item = this.addTooltipData(item, i++);
                items.push(item);
            }
        }
        this.getTemplateViewModel().isMutliLevel(true);
        this.getTemplateViewModel().groups(groups);
        this.getTemplateViewModel().items(items);
        this.getTemplateViewModel().selectionLimit(0);
    }
    createDescriptionTooltip(i, description) {
        let tooltip = new infoButton_template('tooltip-' + i++, this.getTemplateViewModel(), this.caller);
        tooltip.setContent(description);
        return tooltip;
    }
    setLabel(label) {
        this.getTemplateViewModel().label(label);
    }
    setFilterContainerClass(className) {
        this.filterContainerClass = className;
    }
    setTagContainerId(id) {
        this.tagContainerId = id;
    }
    setTagContainerCaption(caption) {
        this.tagContainerCaption = caption;
    }
    addCaption() {
        if (this.getTagContainer()) {
            this.getTagContainer().appendChild(this.createCaption());
        }
    }
    addTag(tag) {
        if (this.getTagContainer()) {
            this.getTagContainer().appendChild(this.createTag(tag));
        }
    }
    createCaption() {
        let element = document.createElement('label');
        element.setAttribute('class', 'small');
        element.appendChild(document.createTextNode(this.tagContainerCaption));
        return element;
    }
    createTag(tag) {
        let huit_neuf_this = this;
        let element = document.createElement('button');
        element.setAttribute('id', tag.id);
        element.setAttribute('class', 'btn-f-s icon i-x-after');
        element.setAttribute('type', 'button');
        element.addEventListener('click', function (e) {
            let selectedItems = [];
            for (let selectedItem of huit_neuf_this.getTemplateViewModel().selectedItems()) {
                if (this.id == `${selectedItem}`) {
                    continue;
                }
                selectedItems.push(selectedItem);
            }
            for (let selectedItemOrderBySelection of huit_neuf_this.getTemplateViewModel().selectedItemsOrderBySelection()) {
                if (this.id == selectedItemOrderBySelection) {
                    huit_neuf_this.getTemplateViewModel().selectedItemsOrderBySelection.remove(selectedItemOrderBySelection);
                }
            }
            huit_neuf_this.getTemplateViewModel().selectedItems(selectedItems);
            huit_neuf_this.applyFilter();
            if (selectedItems.length > 0) {
                this.parentNode.removeChild(this);
            }
            else {
                huit_neuf_this.removeTagContainer();
            }
            huit_neuf_this.checkLimit();
        }, false);
        element.appendChild(document.createTextNode(tag.name));
        return element;
    }
    applyFilter() {
        this.caller.filterMultipleSelectorOnChange(this.idElement);
    }
    getTagContainer() {
        return document.getElementById(this.tagContainerId);
    }
    removeTagContainer() {
        if (document.getElementById(this.tagContainerId)) {
            document.getElementById(this.tagContainerId).innerHTML = '';
        }
    }
    addCaptionAndSelectedTags() {
        let allItems = this.getItems();
        let selectedIdItems = this.getSelectedItems();
        let selectedItems = allItems.filter((i) => selectedIdItems.includes(i.id));
        if (selectedItems.length > 0) {
            this.addCaption();
            for (let s of selectedItems) {
                this.addTag(s);
            }
        }
    }
    updateSelectedItemsOrderBySelection(lastSelectedItem) {
        let alreadySelectedOrderedItems = this.viewModel[this.idElement].selectedItemsOrderBySelection();
        let itemAlreadySelected = false;
        for (let alreadySelectedOrderedItem of alreadySelectedOrderedItems) {
            if (alreadySelectedOrderedItem == lastSelectedItem.id) {
                this.viewModel[this.idElement].selectedItemsOrderBySelection.remove(alreadySelectedOrderedItem);
                itemAlreadySelected = true;
            }
        }
        if (!itemAlreadySelected) {
            this.viewModel[this.idElement].selectedItemsOrderBySelection.push(lastSelectedItem.id);
        }
    }
    setSelectionLimit(limit) {
        this.viewModel[this.idElement].selectionLimit(limit);
        if (limit > 0) {
            this.viewModel[this.idElement].selectAllEnabled(false);
        }
    }
    setSelectAllEnabled(flag) {
        if (flag) {
            this.viewModel[this.idElement].selectionLimit(0);
        }
        this.viewModel[this.idElement].selectAllEnabled(flag);
    }
    setSearchEnabled(flag) {
        this.viewModel[this.idElement].searchEnabled(flag);
    }
    setDisplaySelectionOrder(flag) {
        this.viewModel[this.idElement].displaySelectionOrder(flag);
    }
    getSelectedItems() {
        return this.viewModel[this.idElement].selectedItems();
    }
    getSelectedGroups() {
        return this.getTemplateViewModel().selectedGroups();
    }
    getOpenedGroupsDrawers() {
        return this.getTemplateViewModel().openedGroupsDrawers();
    }
    getItems() {
        return this.getTemplateViewModel().items();
    }
    getGroups() {
        return this.getTemplateViewModel().groups();
    }
    getSearchValue() {
        return this.getTemplateViewModel().searchValue();
    }
    //
    // Adds tooltip data to an object.
    addTooltipData(obj, index) {
        if (obj.hasOwnProperty('description') && obj['description']) {
            obj['tooltip'] = this.createDescriptionTooltip(index++, obj['description']);
        }
        return obj;
    }
    setIsDisabled(value) {
        this.getTemplateViewModel().isDisabled(value);
    }
}
